module.exports = __webpack_public_path__ + "static/media/photo24.784a5fd8.jpg";